import React from "react";
import { FaLinkedin, FaGithub } from "react-icons/fa";

const Contact = () => {
  return (
    <section name="contact" className="w-full bg-[#2F4156] py-12">
      <div className="max-w-5xl mx-auto px-6">
        <div className="rounded-2xl p-12 bg-[#F5EFEB] text-center">
          <p className="text-sm font-medium text-[#567C8D] tracking-widest uppercase mb-4">
            Contact
          </p>
          <h2 className="text-4xl font-bold text-[#2F4156] mb-4">
            Let's work together.
          </h2>
          <p className="text-[#567C8D] max-w-md mx-auto mb-10 leading-relaxed">
            Open to QA engineering roles — manual, automation, or mixed.
            Reach out on LinkedIn or explore my work on GitHub.
          </p>

          <div className="flex justify-center gap-4 flex-wrap">
            <a href="https://www.linkedin.com/in/jasper-manalo-006207126/" target="_blank" rel="noreferrer"
              className="flex items-center gap-2 px-6 py-3 bg-[#2F4156] text-[#F5EFEB] text-sm font-medium rounded-md hover:bg-[#567C8D] transition-colors">
              <FaLinkedin size={16} />
              LinkedIn
            </a>
            <a href="https://github.com/jasper1001" target="_blank" rel="noreferrer"
              className="flex items-center gap-2 px-6 py-3 border border-[#567C8D] text-[#2F4156] text-sm font-medium rounded-md hover:border-[#2F4156] transition-colors">
              <FaGithub size={16} />
              GitHub
            </a>
          </div>
        </div>

        <p className="text-center text-xs text-[#C8D9E6] mt-10">
          © {new Date().getFullYear()} Jasper Manalo
        </p>
      </div>
    </section>
  );
};

export default Contact;
